import { DependencyList, useCallback, useState } from 'react'
import { RequestCallback, RequestSending } from 'types/hooks/request'

export default function useRequest<T>(
  request: RequestCallback<T>,
  deps: DependencyList = []
): [RequestCallback<T>, RequestSending] {
  // sending state
  const [requestCount, setRequestCount] = useState<number>(0)

  // call back to run request code
  const sendRequest = useCallback(
    async (...args: any[]): Promise<any> => {
      try {
        setRequestCount((count: number) => count + 1)
        return await request?.(...args)
      } finally {
        setRequestCount((count: number) => count - 1)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  )

  return [sendRequest, requestCount > 0]
}
